<template>
  <v-container fluid>
    <v-row>
      <v-col v-for="n in 12" :key="n" class="d-flex child-flex" cols="3">
        <v-hover v-slot:default="{ hover }">
          <v-card flat tile class="d-flex">
          <v-img
            :src="src[n-1]"
            :lazy-src="src[n-1]"
            @click="MostrarImagen(src[n-1])"
            aspect-ratio="1"
            class="grey lighten-2"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>

            <v-expand-transition>
              <div
                v-if="hover"
                class="d-flex transition-fast-in-fast-out v-card--reveal display-3 white--text"
                style="height: 100%; background: #E8175D;"
                v-text="$t('clickimagen[0]')"
              ></div>
            </v-expand-transition>
          </v-img>
        </v-card>
        </v-hover>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" height="900" width="1200">
      <v-card>
        <v-img :src="srcToShow"></v-img>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      srcToShow: "",
      src: [
        require("../assets/Gallery/M7.jpg"),
        require("../assets/Gallery/NGC-2070.jpg"),
        require("../assets/Gallery/NGC-3372.jpg"),
        require("../assets/Gallery/NGC-6853.jpg"),
        require("../assets/Gallery/noche-pangue.jpg"),
        require("../assets/Gallery/Eclipse.jpg"),
        require("../assets/Gallery/NGC-300.jpg"),
        require("../assets/Gallery/NGC-1976.jpg"),
        require("../assets/Gallery/Eclipse-2.jpg"),
        require("../assets/Gallery/Cerros.jpg"),
        require("../assets/Gallery/Telescopios-1.jpg"),
        require("../assets/Gallery/newton-4.jpg")
      ]
    };
  },
  methods: {
    MostrarImagen(src) {
      this.srcToShow = src;
      this.dialog = true;
    }
  }
};
</script>

<style>
  .v-card--reveal {
    align-items: center;
    bottom: 0;
    justify-content: center;
    opacity: .5;
    position: absolute;
    width: 100%;
  }
</style>